import React from 'react';
import { NavLink } from 'react-router-dom';

export default function PageNavigation() {
    return (
        <ul className="navigation-tabs__list">
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="users"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Users
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="settings"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Settings
                </NavLink>
            </li>
        </ul>
    );
}
